__turbopack_context__.v({
  "loginFormArea": "login-page-module__vTtAsa__loginFormArea",
  "loginFormAreaMobileScrollable": "login-page-module__vTtAsa__loginFormAreaMobileScrollable",
  "loginHero": "login-page-module__vTtAsa__loginHero",
  "loginHeroCopy": "login-page-module__vTtAsa__loginHeroCopy",
  "loginHeroCopyStrong": "login-page-module__vTtAsa__loginHeroCopyStrong",
  "loginHeroNav": "login-page-module__vTtAsa__loginHeroNav",
  "loginHeroNavLink": "login-page-module__vTtAsa__loginHeroNavLink",
  "loginHeroNavLinkActive": "login-page-module__vTtAsa__loginHeroNavLinkActive",
  "loginHeroOverlay": "login-page-module__vTtAsa__loginHeroOverlay",
  "loginInput": "login-page-module__vTtAsa__loginInput",
  "loginShell": "login-page-module__vTtAsa__loginShell",
  "loginShellMobileFixed": "login-page-module__vTtAsa__loginShellMobileFixed",
  "loginShellMobileScrollable": "login-page-module__vTtAsa__loginShellMobileScrollable",
});
